import React from 'react'

import Spinner from '../../../components/Spinner'

import {
    Container, Avatar
} from './styles'

import avatarDefault from '../../../assets/images/avatar.png'

export default function ({ pessoa, className = '' }) {
    return (
        <Container className={`animated fadeInUp delay-100ms ${className}`}>
            {pessoa ? (
                <>
                    <Avatar
                        image={pessoa.usuario?.avatar?.link || avatarDefault}
                        className="animated zoomIn faster"
                    />

                    <h1 style={{ gridArea: 'nome' }} className="nome_completo text-slate-800">{pessoa.nome}</h1>

                    <h1 style={{ gridArea: 'nome' }} className="nome_reduzido text-slate-800">{pessoa.nome_reduzido}</h1>
                </>
            ) : (
                <Spinner />
            )}
        </Container>
    )
}
